import { all, spawn } from 'redux-saga/effects';

import SecuritySaga from 'yeself-client-common/security/SecuritySaga';
import FeatureFlagsSaga from 'yeself-client-common/featureFlags/FeatureFlagsSaga';

import EnvironmentConfiguration from 'yeself-client-common/EnvironmentConfiguration';

import settingsSaga from 'Console/data/applicationDetail/settings/SettingsSaga';
import YesElfIntegrationSaga from 'Console/data/yeselfIntegration/YeselfIntegrationSaga';
import recordingSaga from 'Console/data/applicationDetail/guides/recording/RecordingSaga';
import organizationsSaga from 'Console/data/organizations/OrganizationsSaga';

import appSaga from 'Console/data/app/saga';
import applicationsSaga from 'Console/data/applications/saga';
import guidesSaga from 'Console/data/applicationDetail/guides/saga';
import accountsSaga from 'Console/data/accounts/saga';
import auditSaga from 'Console/data/audit/saga';
import themesSaga from 'Console/data/applicationDetail/themes/saga';
import segmentsSaga from 'Console/data/applicationDetail/segments/saga';

import analyticsSaga from './analytics/AnalyticsSaga';

function* rootSaga() {
    yield spawn(SecuritySaga, {
        url: EnvironmentConfiguration.OPEN_ID.url,
        realm: EnvironmentConfiguration.OPEN_ID.realm,
        clientId: EnvironmentConfiguration.OPEN_ID.console_client_id,
    });

    yield spawn(appSaga);
    yield spawn(applicationsSaga);
    yield spawn(settingsSaga);
    yield spawn(guidesSaga);
    yield spawn(accountsSaga);
    yield spawn(auditSaga);
    yield spawn(themesSaga);
    yield spawn(segmentsSaga);
    yield spawn(recordingSaga);
    yield spawn(YesElfIntegrationSaga);
    yield spawn(organizationsSaga);
    yield spawn(FeatureFlagsSaga);
    yield spawn(analyticsSaga);
}

export default rootSaga;
